import { useCallback, useEffect, useState } from "react"
import Table from "../components/Table"
import CreateUserModal from "../components/Users/CreateUserModal"
import UserMoreModal from "../components/Users/UserMoreModal"
import Sidebar from "../components/Sidebar"
import { useAuth } from "../lib/useAuth"
import { useSocket, useSocketEvent } from "../contexts/SocketContext"
import { APP_ROUTES } from "../utils/constants"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"
import LogsModal from "../components/LogsModal"
import sidebarStore from "../store/sidebarStore"

const cols = [
    {
        name: "وضعیت",
        colSpan: 1,
    },
    {
        name: "نام کاربری",
        colSpan: 1,
    },
    {
        name: "نقش",
        colSpan: 1,
    },
    {
        name: "موجودی",
        colSpan: 1,
    },
    {
        name: "توضیحات",
        colSpan: 1,
    },
    {
        name: "",
        colSpan: 1,
    },
]

const Users = () => {
    const { user } = useAuth()
    const { isConnected, sendMessage } = useSocket()
    const navigate = useNavigate()

    const [rows, setRows] = useState(null)
    const [userList, setUserList] = useState(null)
    const [createIsOpen, setCreateIsOpen] = useState(false)

    const [searchBar, setSearchBar] = useState("")
    const setSection = sidebarStore((state) => state.setSection)

    const searchBarChangeHandler = async (e) => {
        await new Promise((resolve) => setTimeout(resolve, 500))
        setSearchBar(e.target.value)
    }

    const toggleCreate = () => {
        setCreateIsOpen(!createIsOpen)
    }
    const createRows = (userList) => {
        return userList.map((u) => {
            let obj = {
                status: (
                    <span className={u.status === "active" ? "bg-blur-success" : "bg-blur-warning"}>
                        {u.status === "active" ? "فعال" : "غیرفعال"}
                    </span>
                ),
                username: u.username,
                scope: u.scope === "admin" ? "ادمین" : "نماینده",
                balance: u.balance.toLocaleString("en-US"),
                info: u.info,
                more: (
                    <div className="flex gap-2">
                        <UserMoreModal user={u} requestUser={user} />
                        <LogsModal service={{ en: "user", fa: "کاربر" }} id={u.id} />
                    </div>
                ),
            }
            return obj
        })
    }

    const handleUserList = useCallback((data) => {
        setUserList(data)
    }, [])

    const handleUserAdded = useCallback((newUser) => {
        setUserList((list) => [...list, newUser])
    }, [])

    const handleUserUpdated = useCallback((newData) => {
        setUserList((oldUserList) => {
            return oldUserList.map((s) => {
                return s.id == newData.id ? Object.assign(s, newData) : s
            })
        })
    }, [])

    const handleUserDeleted = useCallback((deletedId) => {
        setUserList((oldBotList) => {
            return oldBotList.filter((s) => s.id != deletedId)
        })
    }, [])

    useSocketEvent("userList", handleUserList)
    useSocketEvent("userAdded", handleUserAdded)
    useSocketEvent("userUpdated", handleUserUpdated)
    useSocketEvent("userDeleted", handleUserDeleted)

    const handleRefresh = () => {
        sendMessage("getUserList")
    }

    useEffect(() => {
        if (user && user.scope == "admin") {
            sendMessage("getUserList")
        } else if (user && user.can_use_servers) {
            navigate(APP_ROUTES.INDEX)
        } else if (user && user.can_use_manager_bots) {
            navigate(APP_ROUTES.TS_MANAGER_BOTS)
        } else if (user) {
            toast.error("شما هیچگونه دسترسی ندارید")
            localStorage.clear()
            navigate(APP_ROUTES.SIGN_IN)
        } else {
            return
        }
    }, [user, isConnected])

    const section = {
        title: "کاربرها",
        setSearchBar: searchBarChangeHandler,
        buttons: [
            {
                name: "ساخت کاربر جدید",
                onClick: toggleCreate,
                color: "border",
                iconName: "square-plus",
            },
        ],
    }

    useEffect(() => {
        if (searchBar && searchBar !== "" && userList) {
            let searchedRows = userList.filter((user) => {
                if (!user.username.toString().includes(searchBar)) {
                    return false
                } else {
                    return true
                }
            })
            setRows(createRows(searchedRows))
        } else if (userList) {
            setRows(createRows(userList))
        }
    }, [userList, searchBar])

    if (!user) {
        return <div>...در حال بارگذاری</div>
    }

    setSection(section)

    return (
        <>
            <CreateUserModal userList={userList} isOpen={createIsOpen} toggleModal={toggleCreate} />
            <Table cols={cols} rows={rows} paging={{ maxRows: 20 }} handleRefresh={handleRefresh} />
        </>
    )
}

export default Users
